import { cx } from '@libs/classnames';

import { TournamentMode } from '@features/shared/api/typings';
import { TOURNAMENT_MODES } from '@features/shared/constants';

import styles from './EventMode.module.css';

export type Props = {
  className?: string;
  tournament?: {
    mode: TournamentMode;
  };
};

export function EventMode({ className, tournament }: Props) {
  if (!tournament) return null;

  const mode = TOURNAMENT_MODES[tournament.mode];

  return <span className={cx(className, styles.root)}>{mode}</span>;
}
